import { IAssignment } from '@medely/types';
import { centsToCurrency } from '@mp/utils';

export const displayParking = (assignment: IAssignment): string => {
  if (assignment.primary_location.parking_free) {
    return 'Parking is free';
  }
  if (assignment.primary_location.parking_reimbursed) {
    return `Parking is reimbursed • ${centsToCurrency(
      assignment.primary_location.parking_reimbursement_cents || 0,
    )} daily`;
  }
  if (assignment.primary_location.parking_validated) {
    return 'Parking is validated';
  }
  if (assignment.primary_location.parking_cost_cents !== undefined) {
    return `Parking is not reimbursed • ${centsToCurrency(
      assignment.primary_location.parking_reimbursement_cents || 0,
    )} daily`;
  }
  return '';
};
